import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b0a1a9ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_movies_banner = _resolveComponent("movies-banner")!
  const _component_movies_carousel = _resolveComponent("movies-carousel")!
  const _component_movie_modal = _resolveComponent("movie-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_movies_banner, {
      movies: _ctx.bannerMovies,
      onOnOpenModal: _ctx.getMovieData
    }, null, 8, ["movies", "onOnOpenModal"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_movies_carousel, {
        "section-title": "Mais populares",
        movies: _ctx.popularMovies,
        onOnOpenModal: _ctx.getMovieData
      }, null, 8, ["movies", "onOnOpenModal"]),
      _createVNode(_component_movies_carousel, {
        "section-title": "Lançamentos",
        movies: _ctx.upcomingMovies,
        onOnOpenModal: _ctx.getMovieData
      }, null, 8, ["movies", "onOnOpenModal"]),
      _createVNode(_component_movies_carousel, {
        "section-title": "Melhores Filmes",
        movies: _ctx.topMovies,
        onOnOpenModal: _ctx.getMovieData
      }, null, 8, ["movies", "onOnOpenModal"]),
      _createVNode(_component_movies_carousel, {
        "section-title": "Nos cinemas",
        movies: _ctx.nowPlaying,
        onOnOpenModal: _ctx.getMovieData
      }, null, 8, ["movies", "onOnOpenModal"]),
      _createVNode(_component_movie_modal, {
        id: _ctx.movieId,
        "show-modal": _ctx.showModal,
        onCloseModal: _ctx.cleanModalData
      }, null, 8, ["id", "show-modal", "onCloseModal"])
    ])
  ], 64))
}